<template>
  <div class="book-page">
    <div class="page-title">校园认证</div>
    <div class="page-tip">
      图书个人用户需先完成校园认证，认证后可进行教材激活开通。
    </div>
    <el-form
      ref="authForm"
      :model="form"
      :rules="rules"
      label-width="100px"
      class="auth-form"
      v-loading="loading"
    >
      <el-form-item label="学校" prop="collegePath">
        <el-cascader
          ref="collegeCascader"
          v-model="form.collegePath"
          :options="collegeOptions"
          :props="cascaderProps"
          placeholder="请选择学校"
          clearable
          @change="onCollegeChange"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item label="学号" prop="studentNo">
        <el-input
          v-model.trim="form.studentNo"
          placeholder="请输入学号"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model.trim="form.name"
          placeholder="请输入姓名"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="submitLoading" @click="submit"
          >提交认证</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getCollegeDetailInfo } from "@/api/login";
import { campusAuthBookUser } from "@/api/bookUser";

export default {
  name: "BookCampusAuthIndex",
  data() {
    return {
      loading: false,
      submitLoading: false,
      collegeOptions: [],
      cascaderProps: {
        value: "id",
        label: "label",
        children: "children",
        emitPath: true
      },
      form: {
        collegePath: [],
        collegeId: null,
        studentNo: "",
        name: ""
      },
      rules: {
        collegePath: [
          { required: true, message: "请选择学校", trigger: "change" }
        ],
        studentNo: [{ required: true, message: "请输入学号", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.loadCollegeOptions();
  },
  methods: {
    async loadCollegeOptions() {
      this.loading = true;
      try {
        const res = await getCollegeDetailInfo();
        if (res.code === 200 || res.code === 0) {
          this.collegeOptions = this.normalizeCollegeOptions(res.data || []);
        } else {
          this.$message.error(res.message || "加载学校列表失败");
        }
      } finally {
        this.loading = false;
      }
    },
    normalizeCollegeOptions(options) {
      return options.map(item => {
        const option = {
          ...item,
          label: item.label || item.name || item.collegeName || ""
        };
        if (Array.isArray(item.children) && item.children.length > 0) {
          option.children = this.normalizeCollegeOptions(item.children);
        }
        return option;
      });
    },
    onCollegeChange(value) {
      this.form.collegeId = null;
      if (!Array.isArray(value) || value.length === 0) {
        return;
      }
      const leaf = value[value.length - 1];
      if (typeof leaf === "number") {
        this.form.collegeId = leaf;
        return;
      }
      if (typeof leaf === "string") {
        const parts = leaf.split("-");
        const collegeId = parts[parts.length - 1];
        if (parts.length >= 3 && !Number.isNaN(Number(collegeId))) {
          this.form.collegeId = Number(collegeId);
          return;
        }
        if (!Number.isNaN(Number(leaf))) {
          this.form.collegeId = Number(leaf);
        }
      }
    },
    submit() {
      this.$refs.authForm.validate(async valid => {
        if (!valid) {
          return;
        }
        if (!this.form.collegeId) {
          this.$message.error("请选择有效学校");
          return;
        }
        this.submitLoading = true;
        try {
          const res = await campusAuthBookUser({
            collegeId: this.form.collegeId,
            studentNo: this.form.studentNo,
            name: this.form.name
          });
          if (res.code === 200 || res.code === 0) {
            this.$message.success("校园认证成功");
            this.$router.replace("/bookCourse");
          } else {
            this.$message.error(res.message || "校园认证失败");
          }
        } finally {
          this.submitLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.book-page {
  background: #fff;
  padding: 16px;
  border-radius: 10px;
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
}
.page-tip {
  margin-bottom: 18px;
  color: #606266;
}
.auth-form {
  max-width: 560px;
}
</style>
